import { useState, useEffect } from "react";
import AnimatedPageContainer from "../../../assets/containers/AnimatedPageContainer";
import GameBoard from "./GameBoard";
import { useParams } from "react-router";
import errorHandler from "../../../assets/utils/ErrorHandler";
import { getWordGameById } from "../../../assets/services/apiServices";
import Loading from "../../../assets/containers/loadingDialog";
import WordGameHintDialog from "../alertContents/WordGameHintDialog";
import { baseURL } from "../../../assets/constants/baseUrl";
import TimerIcon from "../../../assets/images/icons/timer.svg";
import WordGameEndTimeDialog from "../alertContents/WordGameEndTimeDialog";

const WordGame = () => {
  const [loadingGetData, setLoadingGetData] = useState(true);
  const [gameData, setGameData] = useState(null);
  const [showEndTimeDialog, setShowEndTimeDialog] = useState(false);
  const [remaingTime, setRemaingTime] = useState(0);
  const { id } = useParams();

  useEffect(() => {
    fetchGameData();
  }, [id]);

  const fetchGameData = async () => {
    try {
      const response = await getWordGameById(id);
      setGameData(response.data);
    } catch (err) {
      errorHandler(err);
    } finally {
      setLoadingGetData(false);
    }
  };

  useEffect(() => {
    if (!gameData) return;
    if (!gameData.eventId?.durationEnabled) return;
    const startTime = new Date(gameData.createdAt);
    const durationMinutes = gameData.durationMinutes;
    const endTime = new Date(
      startTime.getTime() + durationMinutes * 60000
    ).getTime();
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const remaining = endTime - now;
      if (remaining <= 0) {
        setRemaingTime(0);
        setShowEndTimeDialog(true);
        clearInterval(interval);
      } else {
        setRemaingTime(remaining);
      }
    }, 1000);
    return () => {
      setShowEndTimeDialog(false);
    };
  }, [gameData]);

  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        {gameData?.eventId?.durationEnabled && (
          <div className="d-flex justify-content-end align-items-center my-2 blueColor">
            <span>
              {String(Math.floor((remaingTime / 1000 / 60) % 60)).padStart(
                2,
                "0"
              ) +
                ":" +
                String(Math.floor((remaingTime / 1000) % 60)).padStart(2, "0")}
            </span>
            <img src={TimerIcon} alt="timer" className="mr-2" />
          </div>
        )}
        <img
          src={
            gameData?.eventId?.wordPoster
              ? `${baseURL}file/get/${gameData.eventId.wordPoster}`
              : "/images/wordGame/wordGamePoster.png"
          }
          className="img-fluid w-100 my-4"
          alt="wordGamePreview"
        />
        <p className="text-right">کلمه مورد نظر ما را حدس بزنید.😄</p>
        <hr />
        {loadingGetData ? (
          <div className="d-flex justify-content-center">
            <Loading />
          </div>
        ) : (
          <>
            <GameBoard data={gameData} gameId={id} />
            {/* <div className="pb-4">
              <button
                className={`${classes.wordGameButton} ${classes.purplueButton}`}
              >
                ثبت
              </button>
            </div> */}
          </>
        )}
      </div>
      <WordGameHintDialog />
      <WordGameEndTimeDialog showDialog={showEndTimeDialog} />
    </AnimatedPageContainer>
  );
};

export default WordGame;
